import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'ionic-cache';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Cutter_, ToolDetails } from 'src/service/formulas/objects';

import { ServiceProvider } from '../../../service/provider.interface';

@Injectable()
export class EndmillProvider extends ServiceProvider {
  private endmillEndpoint: string;
  private materialsDetailsForEndmillEndpoint: string;
  private toolDetailsForEndmillEndpoint: string;
  private endmillsEndPoint: string;
  private endmillsDetailsEndPoint: string;
  private materialDetailEndPoint: string;
  private token: any;

  constructor(public cache: CacheService, private http: HttpClient) {
    super();
    this.endmillEndpoint = this.config.apiEndpoints['singleEndmill'];
    this.materialsDetailsForEndmillEndpoint = this.config.apiEndpoints['materialsDetailsForEndmill'];
    this.toolDetailsForEndmillEndpoint = this.config.apiEndpoints['toolDetailsForEndmill'];
    this.endmillsEndPoint = this.config.apiEndpoints['endmills'];
    this.endmillsDetailsEndPoint = this.config.apiEndpoints['endmillsDetails'];
    this.materialDetailEndPoint = this.config.apiEndpoints['materialsDetails'];
    this.cache.getItem('loginInfo').then(res => (this.token = res));
  }

  public fetchEndmill = (selectedEndmillProductKey: number): Observable<Cutter_> => {
    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    const url: string = this.endmillEndpoint;

    return this.http
      .get(url, {
        headers: headers,
        params: { productKey: selectedEndmillProductKey.toString() }
      })
      .pipe(
        map((response: Cutter_) => {
          return response;
        }),
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };

  public fetchMaterialIds = (selectedEndmillProductKey: number): Observable<number[]> => {
    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    const url: string = this.materialsDetailsForEndmillEndpoint;

    return this.http
      .get(url, {
        headers: headers,
        params: { productKey: selectedEndmillProductKey.toString() }
      })
      .pipe(
        map((response: number[]) => {
          return response;
        }),
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };

  public fetchToolDetailsForEndmill = (selectedEndmillProductKey: number): Observable<ToolDetails> => {
    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    const url: string = this.toolDetailsForEndmillEndpoint;

    return this.http
      .get(url, {
        headers: headers,
        params: { productKey: selectedEndmillProductKey.toString() }
      })
      .pipe(
        map((response: ToolDetails) => {
          return response;
        }),
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };

  public getEndmills = (): Observable<any> => {
    const url: string = this.endmillsEndPoint;

    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    return this.http
      .get(url, {
        headers: headers
      })
      .pipe(
        map(response => {
          return response;
        }),
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };

  public getEndmillsDetails = (): Observable<any> => {
    const url: string = this.endmillsDetailsEndPoint;

    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    return this.http
      .get(url, {
        headers: headers
      })
      .pipe(
        map(response => {
          return response;
        }),
        catchError((response: HttpErrorResponse) =>
          observableThrowError(response.error.error_description || 'Server error')
        )
      );
  };

  public getMaterialsDetails = (): Observable<number[]> => {
    const url: string = this.materialDetailEndPoint;

    const headers: HttpHeaders = this.createAuthorizationHeader(this.token.access_token);

    return this.http
      .get(url, {
        headers: headers
      })
      .pipe(
        map((response: number[]) => {
          return response;
        })
      );
  };
}
